"use client";

import { Link, LinkProps, useLocation } from "react-router-dom";
import { addLanguageToPath, getLanguageFromPath } from "@/lib/language";

interface LanguageLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
}

/**
 * A Link component that automatically handles language prefixes
 * Use this instead of regular Link components for internal navigation
 */
export function LanguageLink({ to, children, ...props }: LanguageLinkProps) {
  const location = useLocation();

  // Get current language from URL
  const currentLang = getLanguageFromPath(location.pathname);

  // Add current language prefix to the destination path
  const localizedPath = addLanguageToPath(to, currentLang);

  return (
    <Link to={localizedPath} {...props}>
      {children}
    </Link>
  );
}